import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Mixins, Spacing, Transition } from 'web-common/src/shared/styles';
import { LOGO_WIDTH, NAV_HEIGHT } from '../consts';

export const Container = styled.div<{ hide?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: ${LOGO_WIDTH};

  ${ifProp(
    'hide',
    Mixins.Media.maxWidthSmall(css`
      margin-top: -${NAV_HEIGHT};
      margin-right: calc(-${LOGO_WIDTH} - ${Spacing.SINGLE});
      opacity: 0;
      pointer-events: none;
      transition: margin-top ${Transition.Time.BASE}, opacity ${Transition.Time.BASE},
        margin-right ${Transition.Time.BASE} 0;
    `),
    Mixins.Media.maxWidthSmall(css`
      margin-top: 0px;
      margin-right: 0px;
      opacity: 1;
      pointer-events: all;
      transition: margin-top ${Transition.Time.BASE}, opacity ${Transition.Time.BASE},
        margin-right 0s ${Transition.Time.BASE};
    `)
  )}

  & > * {
    transform: translateY(-1px);
  }
`;
